var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"card-container"},[_vm._t("header"),_c('md-card-content',{staticClass:"card-content",style:(!_vm.hasPadding_ && { padding: '0px' })},[_vm._t("content")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }